import { useState } from "react"

const mailURL = `https://api.peoplevine.com/survey.asmx/answerSurvey`

type ScalarValue = string | number | boolean

type PayloadData = { [key: number]: ScalarValue }

type State = {
  success: boolean | undefined
  requestSent: boolean
  error: string | undefined
  sendEmail: (id: number, data: PayloadData, request?: RequestInit, authConfig?: AuthType) => void
}

type SurveyPayload = {
  survey_no: number
  survey_field_no: number
  survey_answer: ScalarValue
}[]

export type AuthType = {
  api_username: string
  api_password: string
  api_key: string
  company_no: number
  username: string
  password: string
}

/**
 * Wraps request body into Survey API entity and sends POST request to add email into queue
 * @param id Survey ID created in CRM with required mail template
 */
export function useSurveyApi(): State {
  const [success, setSuccess] = useState<boolean>()
  const [error, setError] = useState<string>()
  const [requestSent, setRequestSent] = useState(false)

  const sendEmail = (id: number, data: PayloadData, options?: RequestInit) => {
    const answers: SurveyPayload = []

    Object.entries(data).forEach(([key, value]) =>
      answers.push({
        survey_no: id,
        survey_field_no: Number.parseInt(key),
        survey_answer: value,
      })
    )
    const auth = {
      api_username: import.meta.env.REACT_APP_PUBLIC_API_USERNAME || "",
      api_password: import.meta.env.REACT_APP_PUBLIC_API_PASSWORD || "",
      api_key: import.meta.env.REACT_APP_PUBLIC_API_KEY || "",
      company_no: Number(import.meta.env.REACT_APP_PUBLIC_COMPANY_NO || 0),
      username: import.meta.env.REACT_APP_PUBLIC_USERNAME || "",
      password: import.meta.env.REACT_APP_PUBLIC_PASSWORD || "",
    }

    const payload = { answers, auth }

    const request: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      ...options,
    }

    if (process.env.NODE_ENV === "development") {
      console.log(`Sending email with payload: ${request.body}`)
      console.log("Auth Values:", auth)
      setSuccess(true)
      setError("Stub error text")
    } else {
      answers.length > 0 &&
        fetch(mailURL, request)
          .then(response => setSuccess(response.ok))
          .catch(reason => {
            console.log(reason)
            setError(reason.toString())
          })
    }
    return setRequestSent(true)
  }

  return { sendEmail, success, error, requestSent }
}
